import React from 'react';
import { Link } from 'react-router-dom';

// Single source of truth for the merchant details printed on every policy
// page. Cashfree's risk review checks these against the account's KYC.
export const MERCHANT = {
  brand: 'Driveline',
  legal: 'Unisol Global',
  address: 'No. 13, SH 104, Maruthi Nagar, Yelahanka, Bangalore, Karnataka 560064, India',
  email: 'unisol.globalai@gmail.com',
  phone: '+91 99161 20561',
  hours: 'Mon–Sat, 9:30 AM – 6:00 PM IST',
};

export const LAST_UPDATED = '20 June 2026';

export const POLICY_LINKS = [
  { to: '/driveline', label: 'Overview' },
  { to: '/driveline/pricing', label: 'Pricing' },
  { to: '/driveline/guides', label: 'Guides' },
  { to: '/driveline/refund-policy', label: 'Refund & Cancellation' },
  { to: '/driveline/terms', label: 'Terms of Service' },
  { to: '/driveline/privacy', label: 'Privacy Policy' },
];

export const Section = ({ title, children, testid }) => (
  <section className="mt-10" data-testid={testid}>
    <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="space-y-2 pl-4">
    {items.map((t, i) => (
      <li key={i} className="list-disc text-sm leading-relaxed text-slate-600 marker:text-teal-600">
        {t}
      </li>
    ))}
  </ul>
);

export const PolicyPage = ({ title, intro, children, testid }) => (
  <div className="driveline-scope min-h-screen bg-[#FAFAF8] pt-32 pb-20" data-testid={testid}>
    <div className="max-w-3xl mx-auto px-5 sm:px-8">
      <Link
        to="/driveline"
        className="text-xs uppercase tracking-[0.18em] text-teal-700 hover:text-teal-900"
        data-testid="policy-back"
      >
        Driveline
      </Link>
      <h1 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">{title}</h1>
      {intro && <p className="mt-4 text-base text-slate-500 leading-relaxed">{intro}</p>}
      <p className="mt-4 text-xs text-slate-400" data-testid="policy-updated">
        Last updated {LAST_UPDATED} · Operated by {MERCHANT.legal}, Bangalore, India
      </p>

      <div className="mt-8 border-t border-slate-200" />
      {children}

      <div className="mt-14 rounded-2xl border border-slate-200 bg-white p-6" data-testid="policy-contact">
        <h2 className="text-base font-semibold text-slate-900">Contact us</h2>
        <dl className="mt-3 space-y-1.5 text-sm text-slate-600">
          <div><dt className="inline font-medium text-slate-800">Entity: </dt><dd className="inline">{MERCHANT.legal} ({MERCHANT.brand})</dd></div>
          <div><dt className="inline font-medium text-slate-800">Address: </dt><dd className="inline">{MERCHANT.address}</dd></div>
          <div><dt className="inline font-medium text-slate-800">Email: </dt>
            <dd className="inline"><a className="text-teal-700 underline" href={`mailto:${MERCHANT.email}`}>{MERCHANT.email}</a></dd></div>
          <div><dt className="inline font-medium text-slate-800">Phone: </dt>
            <dd className="inline"><a className="text-teal-700 underline" href={`tel:${MERCHANT.phone.replace(/\s/g, '')}`}>{MERCHANT.phone}</a></dd></div>
          <div><dt className="inline font-medium text-slate-800">Support hours: </dt><dd className="inline">{MERCHANT.hours}</dd></div>
        </dl>
      </div>

      <nav className="mt-8 flex flex-wrap gap-x-5 gap-y-2" data-testid="policy-nav">
        {POLICY_LINKS.map((l) => (
          <Link key={l.to} to={l.to} className="text-sm text-slate-500 hover:text-teal-700 underline-offset-4 hover:underline">
            {l.label}
          </Link>
        ))}
      </nav>
    </div>
  </div>
);
